import Dispatcher from '../Dispatcher';
import ActionTypes from './ActionTypes';

export default {
  fetch() {
    Dispatcher.dispatch({
      actionType: ActionTypes.COLLECTIONS_STORE_FETCH,
    });
  }
}
